import { render, staticRenderFns } from "./war_jch_report.vue?vue&type=template&id=faa95eb0&scoped=true"
import script from "./war_jch_report.vue?vue&type=script&lang=js"
export * from "./war_jch_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa95eb0",
  null
  
)

export default component.exports